export default {
    "msg": {
        "8": "8",
        "20": "20",
        "250": "250",
        "Enter a new password": "ป้อนรหัสผ่านใหม่",
        "Empty": "空",
        "No data": "ไม่มีข้อมูล",
        "Installation Package List": "รายการแพ็กเกจการติดตั้ง",
        "Update Package": "อัปเดตแพ็กเกจ",
      
        "Settings - Profiles": "การตั้งค่า - โปรไฟล์",
        "User Management": "การจัดการผู้ใช้",
        "Operation Records": "บันทึกการดำเนินงาน",
        "Exit": "ออก",
        "Total pages:": "หน้าทั้งหมด:",
        "page": "หน้า",
        "Go to": "ไปที่",
        "Prev": "ก่อนหน้า",
        "Next": "ถัดไป",
        "per page": "แต่ละหน้า",
        "items": "แถบ",
        "Please enter the page number to go to": "โปรดป้อนจำนวนหน้าที่ไป",
        "Language": "ภาษา",
        "Profile Picture": "รูปโปรไฟล์",
        "Old Password": "รหัสผ่านเก่า",
        "New Password": "รหัสผ่านใหม่",
        "Confirm Password": "ยืนยันรหัสผ่าน",
        "The two passwords entered do not match": "รหัสผ่านสองรหัสที่ป้อนไม่ตรงกัน",
        "Enter the new password again": "โปรดป้อนรหัสผ่านใหม่อีกครั้ง",
        "This must match the new password above": "ต้องตรงกับรหัสผ่านใหม่ด้านบน",
        "Lenovo Privacy Statement": "คำชี้แจงสิทธิ์ส่วนบุคคลของ Lenovo",
        "Lenovo Software License Agreement": "ข้อตกลงสิทธิ์การใช้งานซอฟต์แวร์ของ Lenovo",
        "Third-Party Notice": "ประกาศของบุคคลที่สาม",
        "Third-party notifications":"การแจ้งเตือนของบุคคลที่สาม",
        "Change Password": "เปลี่ยนรหัสผ่าน",
        "Edit Profile": "แก้ไขโปรไฟล์",
        "Exited successfully": "ออกสำเร็จแล้ว",
        "Admin": "ผู้ดูแลระบบ",
        "Common user": "ผู้ใช้ทั่วไป",
        "Super Admin":"ผู้ดูแลระบบซุปเปอร์",
        "Model": "รุ่น",
        "Are you sure you want to delete this?": "คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้",
        "Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters": "ป้อนรหัสผ่านใหม่ต้องมีอักขระอย่างน้อยสามรายการต่อไปนี้: ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และอักขระพิเศษ",
        "It must include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters": "ป้อนรหัสผ่านใหม่ต้องมีอักขระอย่างน้อยสามรายการต่อไปนี้: ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และอักขระพิเศษ",
        "Tip": "เคล็ดลับ",
        "Confirm": "ยืนยัน",
        "Cancel": "ยกเลิก",
        "Deletion successful": "การลบสำเร็จ",
        "Password changed successfully": "เปลี่ยนรหัสผ่านสำเร็จแล้ว",
        "The file to upload is larger than 100 MB。 Please select another one。": "ไฟล์ที่จะอัปโหลดมีขนาดใหญ่กว่า 100 MB โปรดเลือกไฟล์อื่น",
        "Your session has expired。 Please log in again。": "สถานะการเข้าสู่ระบบปัจจุบันหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้ง!",
        "Invalid network request URL": "ที่อยู่คำขอเครือข่ายไม่ถูกต้อง!",
        "Unknown server error": "เซิร์ฟเวอร์เกิดข้อผิดพลาดที่ไม่รู้จัก!",
        "An unknown error has occurred": "เกิดข้อผิดพลาดที่ไม่รู้จัก!",
        "Request timeout。 Please check your network and try again。": "คำขอหมดเวลา โปรดตรวจสอบเครือข่ายของคุณ แล้วลองอีกครั้ง",
        "Failed to connect to server": "เชื่อมต่อกับเซิร์ฟเวอร์ไม่สำเร็จ",
        "Your network may be currently disconnected": "เครือข่ายของคุณอาจถูกตัดการเชื่อมต่อในขณะนี้",
        "No related device found": "ไม่พบอุปกรณ์ที่เกี่ยวข้อง",
        "Pre-upgrade component not found in the device": "ไม่พบส่วนประกอบที่อัพเกรดล่วงหน้าในอุปกรณ์",
        "FWID of the installation component not found": "ส่วนประกอบการติดตั้ง FWID ไม่พบ",
        "Failed to set upgrade information": "การตั้งค่าข้อมูลอัพเกรดล้มเหลว",
        "Failed to set specified update options": "ระบุการตั้งค่าการอัพเดตล้มเหลว",
        "Failed to install the update package": "การติดตั้งแพ็กเกจอัพเดตล้มเหลว",
        "Failed to obtain the device handle": "การจัดการอุปกรณ์ล้มเหลว",
        "Upgrade device mismatch": "การอัพเกรดอุปกรณ์ไม่ตรงกัน",
        "Installation failed: Pre-upgrade component not found in the device": "ไม่สามารถติดตั้งได้: ไม่พบส่วนประกอบที่อัพเกรดล่วงหน้าในอุปกรณ์ของคุณ",
        "Installation failed: FWID mismatch in the component list": "ไม่สามารถติดตั้งได้: FWID ไม่ตรงกันในส่วนประกอบ",
        "Installation failed: No matching monitor found for upgrade": "ไม่สามารถติดตั้งได้: ไม่พบการแสดงผลที่ตรงกับการอัพเกรด",
        "The monitor does not exist": "ไม่มีจอภาพนี้",
        "The command has been sent": "ส่งคำสั่งแล้ว",
        "The group does not exist": "ไม่มีกลุ่มนี้",
        "The command does not exist": "ไม่มีคำสั่งนี้",
        "Setting does not exist": "การตั้งค่าไม่มีอยู่",
        "The settings profile does not exist": "ไม่มีโปรไฟล์การตั้งค่านี้",
        "The update package does not exist": "ไม่มีแพ็กเกจการอัปเดตนี้",
        "The update package record does not exist": "ไม่มีบันทึกแพ็กเกจการอัปเดตนี้",
        "Invalid password format。 It must be between 8 and 30 characters long。": "รูปแบบรหัสผ่านไม่ถูกต้อง รหัสผ่านต้องมีความยาว 8 ถึง 30 อักขระ",
        "Password format is incorrect, password must include at least three types of the following: uppercase letters, lowercase letters, digits, and special characters": "密码格式不正确，密码至少包含大写字母、小写字母、数字和特殊字符中的三种类型",
        "The field is empty": "ฟิลด์ว่างเปล่า",
        "Update time cannot be null": "เวลาอัพเกรดไม่สามารถว่างได้",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。": "เวลาอัปเดตไม่ถูกต้อง เวลาอัปเดตต้องไม่อยู่ก่อนเวลาปัจจุบัน หรือไม่เกิน 30 วันในอนาคต",
        "Uploaded file is null": "ไฟล์ที่อัปโหลดว่างเปล่า",
        "Uploaded file format is incorrect， file format can only be zip/exe/dmg/app": "รูปแบบไฟล์ที่อัปโหลดไม่ถูกต้องและรูปแบบไฟล์สามารถเป็น zip/exe/dmg/app เท่านั้น",
        "Uploaded file format is incorrect， file cannot have no extension": "อัปโหลดไฟล์ไม่ถูกต้องรูปแบบไฟล์ไม่สามารถอยู่ได้โดยปราศจากคำต่อท้าย",
        "Login failed。 Make sure you entered the correct account ID and password。": "การเข้าสู่ระบบล้มเหลว ตรวจสอบให้แน่ใจว่าคุณป้อน ID บัญชีและรหัสผ่านที่ถูกต้อง",
        "Date": "วันที่",
        "Time": "เวลา",
        "The data will be permanently deleted": "การกระทำนี้จะลบข้อมูลปัจจุบันอย่างถาวรไม่ว่าจะดำเนินการต่อหรือไม่?",
        "Please select an item to delete first": "กรุณาเลือกรายการก่อนลบ",
        "Select an item and then delete":"เลือกรายการแล้วลบ",
        "Begin Download": "เริ่มดาวน์โหลด",
        "Start Download":"เริ่มดาวน์โหลด",
        "Password incorrect": "รหัสผ่านไม่ถูกต้อง",
        "Password Changed Successfully": "แก้ไขรหัสผ่านสำเร็จ",
        "Display ID or Group ID is empty": "ID จอแสดงผลหรือ ID กลุ่มว่างเปล่า",
        "Select the update package": "เลือกแพ็กเกจการอัปเดต",
        "Username already exists": "มีชื่อผู้ใช้อยู่แล้ว",
        "Executing monitor setting command。Please wait 10s before making new changes。": "คำสั่งการตั้งค่าจอแสดงผลนี้กำลังดำเนินการอยู่ โปรดรอหลังจาก 10 วินาทีก่อนที่จะทำการตั้งค่าใหม่",

        "Close": "ปิด",
        "Role does not exist。 Cannot modify role。": "ไม่มีบทบาทและไม่สามารถปรับเปลี่ยนบทบาทได้",
        "Unknown Command": "ไม่ทราบคำสั่ง",
        "Access Token Expired": "โทเค็นการเข้าถึงหมดอายุ",
        "Invalid Refresh Token": "รีเฟรชโทเค็นที่ไม่ถูกต้อง",
        "Missing Request Parameters:": "พารามิเตอร์การร้องขอหายไป:",
        "Incorrect Request Parameter Type:": "ประเภทพารามิเตอร์การร้องขอผิดพลาด:",
        "Request URL Not Found:": "ไม่มีที่อยู่ที่ร้องขอ:",
        "Incorrect Request Method:": "วิธีการขอไม่ถูกต้อง:",
        "Log In": "เข้าสู่ระบบ",
        "account ID": "หมายเลขบัญชี",
        "password": "รหัสผ่าน",
        "Update failed": "การอัปเดตล้มเหลว",
        "Reset Password?": "รีเซ็ตรหัสผ่าน",
        "Logged in successfully": "เข้าสู่ระบบสำเร็จแล้ว",
        "Please contact the system administrator to reset your password": "โปรดติดต่อผู้ดูแลระบบเพื่อรีเซ็ตรหัสผ่านของคุณ",
        "Retry limit exceeded。 Please try again after 30 minutes": "ลองอีกครั้งมากกว่า 5 ครั้งโปรดลองอีกครั้งหลังจาก 30 นาที",
        "Enter the model / host name / firmware version number": "ป้อนรุ่น / ชื่อโฮสต์ / หมายเลขเวอร์ชันเฟิร์มแวร์",
        "New Group": "กลุ่มใหม่",
        "Delete Group": "ลบกลุ่ม",
        "Display Columns": "แสดงคอลัมน์",
        "Collapse": "ย่อ",
        "Expand": "ขยาย",
        "Move To": "ย้ายไปที่",
        "Export": "导出",
        "Power On": "เปิดเครื่อง",
        "Power Off": "ปิดเครื่อง",
        "Screen lock": "屏幕锁定",
        "Unlock screen": "屏幕解锁",
        "Settings": "การตั้งค่า",
        "Export Settings Profiles": "ส่งออกโปรไฟล์การตั้งค่า",
        "Update": "อัปเดต",
        "Delete Monitor": "ลบจอภาพ",
        "Total devices": "อุปกรณ์ทั้งหมด",
        "Selected devices": "อุปกรณ์ที่เลือก",
        "Update package name": "อัปเดตชื่อแพ็กเกจ",
        "Update Time": "อัปเดตเวลา",
        "Apply to all displays of the same model": "นำไปใช้กับจอแสดงผลรุ่นเดียวกัน",
        "Display Settings": "การตั้งค่าการแสดงผล",
        "Select All": "เลือกทั้งหมด",
        "Settings Profiles": "โปรไฟล์การตั้งค่า",
        "Filename": "ชื่อไฟล์",
        "Group": "กลุ่ม",
        "Monitor Model": "รุ่นจอภาพ",
        "Special ID": "ID พิเศษ",
        "Host Name": "ชื่อโฮสต์",
        "Host Status": "สถานะโฮสต์",
        "Monitor Status": "สถานะจอภาพ",
        "Lock Status": "สถานะล็อค",
        "Update Progress": "ความคืบหน้าในการอัปเดต",
        "Settings Profile": "โปรไฟล์การตั้งค่า",
        "Tips": "เคล็ดลับ",
        "Active Time": "เวลาใช้งาน",
        "Overclock": "โอเวอร์คล็อก",
        "Operation successful": "การดำเนินการสำเร็จ",
        "Please save data": "โปรดบันทึกข้อมูล",
        "Select the data first": "เลือกข้อมูลก่อน",
        "Cannot modify when ungrouped": "ไม่สามารถแก้ไขได้เมื่อยกเลิกการจัดกลุ่ม",
        "Deselect All": "ยกเลิกการเลือกทั้งหมด",
        "Select the GAMMA node label value": "เลือกค่าป้ายกำกับโหนด GAMMA",
        "Ungrouped": "ยกเลิกการจัดกลุ่ม",
        "Offline": "ออฟไลน์",
        "Online": "ออนไลน์",
        "Power on": "เปิดเครื่อง",
        "Power off": "ปิดเครื่อง",
        "Locked": "ล็อคแล้ว",
        "Open": "ไม่ได้ล็อค",
        "Open": "ปลดล็อคแล้ว",
        "Unlocked":"ปลดล็อคแล้ว",
        "Not connected": "ไม่ได้เชื่อมต่อ",
        "Connected": "การเชื่อมต่อ",
        "Set the update start time": "ตั้งเวลาเริ่มต้นการอัปเดต",
        "Now": "ทันที",
        "Set upgrade mode": "ตั้งค่าโหมดอัพเกรด",
        "Interactive Mode": "โหมดโต้ตอบ",
        "Silent mode": "โหมดเงียบ",
        "In this mode， a monitor firmware update screen appears and requests confirmation to proceed。Users may choose to postpone the update twice，after which the update is mandatory。": "ในโหมดนี้ หน้าจออัปเดตเฟิร์มแวร์ของจอภาพจะปรากฏขึ้นและขอให้ผู้ใช้ยืนยันเพื่อดำเนินการต่อ ผู้ใช้สามารถเลือกเลื่อนการอัปเดตได้สองครั้ง หลังจากนั้นระบบจะบังคับให้อัปเดต",
        "In this mode， when the monitor is online， the firmware update will be automatically performed in the background。 Users will not see any notifications。 The update will take effect when the display is restarted。 The restart of the monitor takes about a few seconds， and won’t affect any ongoing tasks on your computer。": "ในโหมดนี้เมื่อจอแสดงผลออนไลน์เฟิร์มแวร์ใหม่จะได้รับการอัปเดตเป็นจอภาพทันทีในรูปแบบโต๊ะในภายหลังและผู้ใช้ไม่เห็นอินเทอร์เฟซใด ๆ แต่เฟิร์มแวร์ใหม่จะไม่มีผลจนกว่าจอแสดงผลจะรีสตาร์ท",
        "Invalid input": "ข้อมูลที่ป้อนไม่ถูกต้อง",
        "Failed to log in": "เข้าสู่ระบบไม่สำเร็จ",
        "Select your preferred restart time。": "ไม่ส่งผลกระทบต่องานที่กำลังทำอยู่บนคอมพิวเตอร์",
        "You have still selected the group that the device currently belongs to。 If you want to move the device， please select another group。": "您点击的仍是设备现属组，若要移动，请选其他组。",
        "Enter the group name": "ป้อนชื่อกลุ่ม",
        "Apply profile:": "ใช้โปรไฟล์:",
        "A new version is available": "เวอร์ชันใหม่พร้อมใช้งานแล้ว",
        "Restart monitor immediately after update": "รีสตาร์ทจอภาพทันทีหลังการอัปเดต",
        "Restart when the monitor enters sleep mode": "รีสตาร์ทอัตโนมัติเมื่อจอภาพเข้าสู่โหมดสลีป",
        "Restart monitor when it disconnected from all PCs": "รีสตาร์ทเมื่อจอแสดงผลถูกตัดการเชื่อมต่อและการเชื่อมต่อพีซีทั้งหมด",
        "Enter the model name": "ป้อนชื่อรุ่น",
        "Create Update Task": "สร้างงานการอัปเดต",
        "Update Task List": "อัปเดตรายการงาน",
        "Cancel All": "ยกเลิกทั้งหมด",
        "View Details": "ดูรายละเอียด",
        "Update Details": "อัปเดตรายละเอียด",
        "Update Mode": "โหมดอัปเดต",
        "Update Creation Time": "อัปเดตเวลาที่สร้าง",
        "Update Start Time": "อัปเดตเวลาเริ่มต้น",
        "Are you sure you want to cancel all tasks?": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกงานทั้งหมด",
        "Are you sure you want to cancel this task?": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกงานนี้?",
        "Are you sure you want to delete the selected monitor?": "คุณแน่ใจหรือไม่ว่าต้องการลบจอภาพที่เลือก",
        "Confirm to delete all displays?": "ยืนยันจะลบจอภาพทั้งหมดหรือไม่",
        "Are you sure you want to delete this？（Cannot delete when ungrouped）": "คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้ (ไม่สามารถลบได้เมื่อยกเลิกการจัดกลุ่ม)",
        "Tip: If an option in the display settings appears grayed out， it may be restricted by another setting。 Try adjusting other settings to remove the restriction。": "เคล็ดลับ: หากตัวเลือกในการตั้งค่าการแสดงผลปรากฏเป็นสีเทา แสดงว่าตัวเลือกนั้นอาจถูกจำกัดโดยการตั้งค่าอื่น ลองปรับการตั้งค่าอื่นๆ เพื่อลบข้อจำกัด",
        "The WebSocket connection has been restored。": "การเชื่อมต่อ WebSocket ได้รับการคืนค่าแล้ว",
        "The previous setting is currently being applied。 Please wait until the value changes before making any new settings。": "การตั้งค่าก่อนหน้าอยู่ระหว่างการดำเนินการโปรดรอจนกว่าตัวเลขจะเปลี่ยนแปลงก่อนที่จะทำการตั้งค่าใหม่",
        "Please copy this password into the input box: ": "โปรดคัดลอกรหัสผ่านนี้ลงในช่องป้อนข้อมูล: ",
        "Ebook": "อีบุ๊ค",
        "largest": "ใหญ่ที่สุด",
        "Max": "สูงสุด",
        "Turn off auto mode": "ปิดโหมดอัตโนมัติ",
        "Minimum": "เล็กที่สุด",
        "Restore Factory Settings": "คืนค่าการตั้งค่าจากโรงงาน",
        "Scenario Mode": "โหมดเหตุการณ์",
        "Color Gamut & Color Temperature": "ขอบเขตสีและอุณหภูมิสี",
        "Close PIP, PBP":"ปิด",
        "PIP window":"PIP",
        "PBP window":"PBP",
        "Neutral": "เป็นกลาง",
        "Panel Native": "แสดงเนทีฟ",
        "Neutral": "เป็นกลาง",
        "Neutral(7500K)":"เป็นกลาง",
        "Reddish(6500K)":"อบอุ่น",
        "Bluish(9300K)":"เย็น",
        "Warm": "อบอุ่น",
        "Cool": "เย็น",
        "Low Blue Light": "แสงสีน้ำเงินต่ำ",
        "Custom 1": "กำหนดเอง 1",
        "Custom 2": "กำหนดเอง 2",
        "Custom 3": "กำหนดเอง 3",
        "BT.709": "BT.709",
        "BT.2020": "BT.2020",
        "Video Signal": "สัญญาณวิดีโอ",
        "Game Mode": "โหมดเกม",
        "Off": "ปิด",
        "Game 1": "เกม 1",
        "Game 2": "เกม 2",
        "Response Time": "เวลาตอบสนอง",
        "Normal": "ปกติ",
        "Extreme": "มากสุด",
        "Level 1": "ระดับ 1",
        "Level 2": "ระดับ 2",
        "Level 3": "ระดับ 3",
        "Level 4": "ระดับ 4",
        "Level 5": "ระดับ 5",
        "Lan Indicator": "ไฟแสดง LAN",
        "Linked": "เชื่อมต่อแล้ว",
        "No Link": "ไม่ได้เชื่อมต่อ",
        "Blinking": "กระพริบ",
        "Brightness": "ความคมชัด",
        "Contrast": "ความสว่าง",
        "Smart Light": "ไฟสมาร์ทไลท์",
        "Volume Control": "การควบคุมระดับเสียง",
        "USB Select": "เลือก USB",
        "DP Select": "เลือก DP",
        "Aspect Ratio": "อัตราส่วนภาพ",
        "Smart Traffic Light": "สัญญาณไฟจราจรอัจฉริยะ",
        "daisy chain": "สายโซ่เดซี่",
        "Dynamic Contrast": "ความคมชัดแบบไดนามิก",
        "Smart Energy": "พลังงานอัจฉริยะ",
        "Smart Audio": "เสียงอัจฉริยะ",
        "Distance Warning": "การแจ้งเตือนระยะห่าง",
        "Ambient Light Detection": "การตรวจจับแสงแวดล้อม",
        "Enabled Ambient Light Detection": "เปิดใช้งานการตรวจจับแสงแวดล้อม",
        "enabled":"enabled",
       "disabled":"disabled",
        "Waken on Touch": "ปลุกสัมผัส",
        "True Split": "ไฟสมาร์ทไลท์",
        "Face Tracking": "ติดตามหน้าคน",
        "Audio Smart Switch": "สวิทซ์เครื่องเสียงชาญฉลาด",
        "Auto-alarm": "ปลุกเตือนอัตโนมัติ",
        "KVM Switch": "สวิตช์ KVM",
        "KVM切换": "สวิตช์ KVM",
        "KVM(Keyboard, Video, Mouse) Switch enables two PCs to use one set of monitor, keyboard and mouse, Enable switching video, keyboard and mouse simultaneously. If disabled, only switch keyboard and mouse.": "สวิตช์ KVM (คีย์บอร์ด, วิดีโอ, เมาส์) ช่วยให้พีซีสองเครื่องใช้จอภาพ แป้นพิมพ์ และเมาส์หนึ่งชุด, เปิดใช้งานการสลับวิดีโอคีย์บอร์ดและเมาส์พร้อมกัน หากปิดใช้งานให้สลับแป้นพิมพ์และเมาส์เท่านั้น",
        "Sitting Reminder": "การเตือนความจำการนั่ง",
        "Gaming": "การเล่นเกม",
        "RGB Gain": "การปรับสี",
        "Serial No": "หมายเลขประจำเครื่อง",
        "Firmware Version": "เวอร์ชันเฟิร์มแวร์",
        "Select response time level": "เลือกระดับเวลาตอบสนอง",
        "Enable daisy chain": "ใช้งาน Daisy Chain",
        "Smart Traffic Light is a do not disturb light, helping to reduce distraction": "ไฟจราจรอัจฉริยะคือไฟห้ามรบกวนช่วยลดความฟุ้งซ่าน",
        "Enable/Disable the Audio Smart function": "ใช้งาน/ปิดใช้งานฟังก์ชั่นเครื่องเสียงชาญฉลาด",
        "Auto-alarm indicates whether the camera/MIC on monitor is in use": "ตัวปลุกเตือนอัตโนมัติแสดงว่ากล้องถ่ายรูป/ไมค์บนจออยุ่ในการใช้งานหรือไม่",
        "Enable Distance Warning": "เปิดใช้งานการแจ้งเตือนระยะห่าง",
        "Enable/disable face tracking": "ใช้งาน/ปิดใช้งานโหมดติดตามหน้าคน",
        "Enable Sitting Reminder": "เปิดใช้งานการเตือนความจำการนั่ง",
        "Smart Audio technology allows you to focus on the sound in front of you to improve voice clarity": "เทคโนโลยีเสียงอัจฉริยะ ช่วยให้คุณสามารถโฟกัสไปที่เสียงข้างหน้าเพื่อปรับปรุงความชัดเจนของเสียง",
        "Smart Energy technology automatically manages energy consumption by human detection sensor": "เทคโนโลยีพลังงานอัจฉริยะจะจัดการการใช้พลังงานโดยอัตโนมัติโดยเซ็นเซอร์ตรวจจับของมนุษย์",
        "Implement PBP through only one cable": "ปฏิบัติการ PBP ผ่านเคเบิลหนึ่งสายเท่านั้น",
        "Enable/Disable vPro technology in the monitor": "ใช้งาน/ปิดใช้งาน vPro",
        "Wake system by touch": "ปลุกระบบโดยการสัมผัส",
        "Set video source and USB source (used by keyboard and mouse) for every PC": "ตั้งค่าแหล่งวิดีโอและแหล่ง USB (ใช้โดยคีย์บอร์ดและเมาส์) สำหรับพีซีทุกเครื่อง",
        "eKVM gives you instant access over two PC sources with a 2-button pressing of your mouse": "eKVM ทำให้คุณเข้าถึงแหล่ง PC ได้อย่างรวดเร็วโดยการกดปุ่มเม้าส์ทั้งสองข้าง",
        "Enable USB charging always on": "เปิดใช้งานการชาร์จ USB ตลอดเวลา",
        "Select DP version": "เลือกเวอร์ชั่น DP",
        "USB Charging": "ชาร์จ USB",
        "PC": "พีซี",
        "Double-click the CTRL": "คลิกสองครั้งที่ CTRL",
        "Full Screen": "เต็มจอ",
        "Original AR": "AR ดั้งเดิม",
        "No scaling": "ไม่มีการปรับขนาด",
        "On": "เปิด",
        "on": "เปิด",
        "Keyboard On": "แป้นพิมพ์ทำงาน",
        "Mouse On": "เม้าส์ทำงาน",
        "Image Creation": "การสร้างสรรค์ภาพ",
        "Digital Cinema": "โรงภาพยนตร์ดิจิทัล",
        "Video Creation": "การสร้างวิดีโอ",
        "Web Browsing": "การท่องเว็บ",
        "Professional Image": "ภาพมืออาชีพ",
        "DisplayPort": "DisplayPort",
        "Auto": "อัตโนมัติ",
        "auto": "อัตโนมัติ",
        "Refresh": "รีเฟรช",
        "Search": "ค้นหา",
        "Record": "บันทึก",
        "Username": "ชื่อผู้ใช้",
        "Upload Time": "เวลาอัปโหลด",
        "Add Profiles": "เพิ่มโปรไฟล์",
        "Latest Update Package": "แพ็กเกจการอัปเดตล่าสุด",
        "Upload Update Package": "อัปโหลดแพ็กเกจการอัปเดต",
        "Upload": "อัปโหลด",
        "Size": "ขนาด",
        "Upload successful": "การอัปโหลดสำเร็จ",
        "Download successful": "ดาวน์โหลดสำเร็จ",
        "Refresh successful": "การรีเฟรชสำเร็จ",
        "The upgrade package does not match the device model": "แพคเกจอัพเกรดไม่ตรงกับรุ่น",
        "Upgrade package does not match the device model":"แพ็กเกจการอัปเกรดไม่ตรงกับรุ่นของอุปกรณ์",
        "Please enter the setting name": "โปรดป้อนชื่อการตั้งค่า",
        "Edit": "แก้ไข",
        "Save": "บันทึก",
        "Delete": "ลบ",
        "Add": "เพิ่ม",
        "Reset Password": "รีเซ็ตรหัสผ่าน",
        "No": "หมายเลข",
        "Full Name": "ชื่อเต็ม",
        "Role": "บทบาท",
        "Creation Date": "วันที่สร้าง",
        "Operation": "การดำเนินการ",
        "Actions": "การดำเนินการ",
        "The user's initial password is ": "该用户的初始密码为 ",
        "The password has been reset to：": "รหัสผ่านได้รับการรีเซ็ตเป็น:",
        "Invalid input。Usernames can only contain numbers and letters。": "ข้อมูลที่ป้อนไม่ถูกต้อง ชื่อผู้ใช้ประกอบด้วยตัวเลขและตัวอักษร",
        "Invalid input。The username must contain 4 to 30 characters。": "ข้อมูลที่ป้อนไม่ถูกต้อง ชื่อผู้ใช้ต้องมีอักขระ 4 ถึง 30 ตัว",
        "Installation Package": "แพ็กเกจการติดตั้ง",
        "Operation Date": "วันที่ดำเนินการ",
        "Actions": "การดำเนินการ",
        "Operator": "ผู้ปฏิบัติการ",
        "Paging component": "Paging component",
        "Quick page flipping": "การเลิกหน้าอย่างรวดเร็ว",
        "Current page": "หน้าปัจจุบัน",
        "Title": "ชื่อ",
        "Details": "รายละเอียด",
        "This is the expanded area": "นี่คือพื้นที่ขยาย",
        "Set Display Column": "ตั้งค่าคอลัมน์แสดงผล",
        "Upload file": "อัพโหลดไฟล์",
        "Drop-down to expand": "ลดลงเพื่อขยาย",
        "Default": "Default",
        "Default Info": "ข้อมูลเริ่มต้น",
        "Personal Center": "ศูนย์ส่วนบุคคล",
        "Personal center image button": "ปุ่มรูปศูนย์ส่วนบุคคล",
        "Expandable area": "พื้นที่ขยายได้",
        "Update Package Table": "อัพเดทตารางแพคเกจ",
        "This is the table header": "นี่คือหัวตาราง",
        "This is the table content": "นี่คือเนื้อหาของตาราง",
        "UserList Table": "ตารางรายการผู้ใช้",
        "Page Up and Down": "หน้าขึ้นและลง",
        "Operation record table": "ตารางบันทึกการดำเนินงาน",
        "OSD upgrade details": "รายละเอียดการอัพเกรด OSD",
        "Lenovo": "Lenovo",
        "Display Fleet Manager": "Display Fleet Manager",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gama": "Gama",
        "PIP/PBP": "PIP/PBP",
        "OSD": "OSD",
        "USB-C Charging": "การชาร์จ USB-C",
        "PIP": "PIP",
        "PBP": "PBP",
        /*
        "Simplified Chinese": "ภาษาจีนตัวย่อ",
        "English": "ภาษาอังกฤษ",
        "Traditional Chinese": "ภาษาจีนดั้งเดิม",
        "French": "ฝรั่งเศส",
        "German": "เยอรมัน",
        "Italian": "อิตาลี",
        "Spanish": "สเปน",
        "Japanese": "ญี่ปุ่น",
        "Thai": "ภาษาไทย",
        "Ukrainian": "ยูเครน",
        "Russian": "ภาษารัสเซีย",
        */
        "Enter your account ID": "ป้อน ID บัญชีของคุณ",
        "Please Enter your account id":"โปรดติดต่อผู้ดูแลระบบเพื่อรีเซ็ตรหัสผ่านของคุณ",
        "Enter your password": "ป้อนรหัสผ่านของคุณ",
        "Cannot exceed 20 characters": "ต้องไม่เกิน 20 อักขระ",
        "Enter the original password": "โปรดป้อนรหัสผ่านเดิม",
        "You have still selected the group that the device currently belongs to. If you want to move the device, please select another group. ": "คุณยังคงเลือกกลุ่มที่อุปกรณ์นี้เป็นสมาชิกอยู่ในปัจจุบัน หากคุณต้องการย้ายอุปกรณ์ โปรดเลือกกลุ่มอื่น ",
        "Enter the filename": "ป้อนชื่อไฟล์",
        "Update Package Name": "อัปเดตชื่อแพ็กเกจ",
        "Select the date": "เลือกวันที่",
        "Select the time": "เลือกเวลา",
        "Set the update mode": "ตั้งค่าโหมดอัปเดต",
        "Restart when the monitor is not connected to any computer": "รีสตาร์ทเมื่อจอภาพไม่ได้เชื่อมต่อกับคอมพิวเตอร์เครื่องใด",
        "Invalid file format": "รูปแบบไฟล์ไม่ถูกต้อง รองรับเฉพาะไฟล์ zip/exe/dmg/app",
        "Select a valid file type": "เลือกประเภทไฟล์ที่ถูกต้อง",

        "The data is being processed。 Please do not submit again。": "กำลังประมวลผลข้อมูล โปรดอย่าส่งซ้ำ",
        "Enter the profiles name": "ป้อนชื่อโปรไฟล์",
        "Enter your username": "ป้อนชื่อผู้ใช้ของคุณ",
        "Enter your full name": "ป้อนชื่อเต็มของคุณ",
        "The initial password of this user is:": "รหัสผ่านเริ่มต้นของผู้ใช้รายนี้คือ: ",
        "Select your role": "เลือกบทบาทของคุณ",
        "User Profile": "โปรไฟล์ผู้ใช้",
        "Downloading": "กำลังดาวน์โหลด…",
        "Enter the new password again。Two times of new password input is same": "โปรดป้อนรหัสผ่านใหม่อีกครั้งรหัสผ่านใหม่ต้องตรงกับรายการที่ป้อนไว้ก่อนหน้านี้",
        "Request failed with status code 502": "คำขอล้มเหลวด้วยรหัสสถานะ 502",

        "Please Enter your x": "ป้อน {param}",
        "Select the x": "เลือก {param}",
        "Please select the correct file type x": "เลือกประเภทไฟล์ที่ถูกต้อง {param}",
        "Please select the correct file type": "เลือกประเภทไฟล์ที่ถูกต้อง",
        "Input characters within x characters": "ต้องไม่เกิน {param} อักขระ",

        "Monitor List":"รายการจอภาพ",
        "List of update packages":"รายการแพ็กเกจอัปเดต",
        "Settings - Profiles":"การตั้งค่า - โปรไฟล์",
        "User Management":"การจัดการผู้ใช้",
    

        "Simplified Chinese": "简体中文",
        "English": "English",
        "Traditional Chinese": "繁體中文",
        "French": "Français",
        "German": "Deutsch",
        "Italian": "Italiano",
        "Spanish": "Español",
        "Japanese": "日本語",
        "Thai": "ภาษาไทย",
        "Ukrainian": "Українська",
        "Russian": "Русский язык",

        "System abnormality":"ความผิดปกติของระบบ",

        "Upgrade Package Record ID is empty":"เลือกแพ็กเกจการอัปเดต",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。":"เวลาอัพเดทที่ไม่ถูกต้อง ไม่สามารถเกินเวลาปัจจุบันหรือมากกว่า 30 วันในอนาคต",
       
        "Invalid input。Password length must be 8–16 characters": "ข้อมูลที่ป้อนไม่ถูกต้อง รหัสผ่านต้องมีความยาว 8-16 อักขระ",
        "Request parameter is invalid:The username must contain 4 to 30 characters。":"พารามิเตอร์การขอไม่ถูกต้อง: ชื่อผู้ใช้ต้องมี 4 ถึง 30 ตัวอักษร",

        "The WebSocket connection has been lost Reconnecting":"การเชื่อมต่อ WebSocket หายไป การเชื่อมต่ออีกครั้ง",
        "Request parameter is invalid：Usernames can only contain numbers and letters。":"พารามิเตอร์การขอไม่ถูกต้อง:ชื่อผู้ใช้ประกอบด้วยตัวเลขและตัวอักษร",

        "Request parameter is invalid:Password length must be between 8-16 character":"พารามิเตอร์การขอไม่ถูกต้อง: ความยาวรหัสผ่านต้องอยู่ระหว่าง 8-16 ตัวอักษร",
        "The compiled package is missing: the component has a corresponding bin that has not been uploaded。Please upload it before compiling":"แพคเกจที่รวบรวมหายไป: ส่วนประกอบมีถังที่เกี่ยวข้องที่ไม่ได้ถูกอัพโหลด。 กรุณาอัพโหลดก่อนการรวบรวม",

        "Request parameter is invalid：Password length must be 8–16 characters":"พารามิเตอร์การขอไม่ถูกต้อง: ความยาวของรหัสผ่านต้องอยู่ระหว่าง 8-16 ตัวอักษร",


        "Illegal request header!": "ส่วนหัวของคำขอไม่ถูกต้อง",
        "Invalid request parameters":"พารามิเตอร์คำขอที่ไม่ถูกต้อง",
        "Export": "ส่งออก",
        "It is already a high-version and there is no need to upgrade":"มันเป็นเวอร์ชั่นสูงแล้วและไม่จำเป็นต้องอัพเกรด",
        "Repeated request, please try again later":"คำขออีกครั้ง โปรดลองอีกครั้งในภายหลัง",
        "Communication":"การสื่อสาร",
    }
}